module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ca38c2c7658b44e276b09b04c440e3d2.png";